export default {
  handleAddCustomerNote () {
    if (!isNaN(this.id)) {
      this.customerNoteCreateId = Number(this.id)
    }
  },
  handleListCustomerNote () {
    if (!isNaN(this.id)) {
      this.customerNoteListId = Number(this.id)
    }
  },
  handleSaveCustomerNote (data) {
    this.customerNote = data
  }
}
